import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function TabletIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M23.9443 1H8.05548C6.36873 1.00225 5.00201 2.5271 5 4.40902V27.591C5.00201 29.4729 6.36873 30.9978 8.05548 31H23.9443C25.631 30.9978 26.998 29.4729 27 27.591V4.40902C26.998 2.5271 25.631 1.00225 23.9443 1ZM16 28.2729C15.3248 28.2729 14.7776 27.6624 14.7776 26.9091C14.7776 26.156 15.3248 25.5455 16 25.5455C16.675 25.5455 17.2221 26.156 17.2221 26.9091C17.2221 27.6624 16.675 28.2729 16 28.2729ZM17.8333 5.09092H14.1667C13.8292 5.09092 13.5555 4.78555 13.5555 4.40902C13.5555 4.03248 13.8292 3.72736 14.1667 3.72736H17.8333C18.1708 3.72736 18.4443 4.03248 18.4443 4.40902C18.4443 4.78555 18.1708 5.09092 17.8333 5.09092Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
